import PasswordField from 'components/password-field/PasswordField';
import SocialLogin from 'components/social-login/SocialLogin';
import PanelPage from 'navigation/pages/PanelPage';
class Auth extends PanelPage {
    static pageName = 'Auth';
    __scrollable = false;
    get scrollable() {
        return this.__scrollable;
    }
    set scrollable(value) {
        this.__scrollable = value;
        this.el.classList.toggle('scrollable', value);
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            passwordField: ['.field input[type="password"]', PasswordField],
            socialLogin: ['.social-login', SocialLogin]
        };
    }
    initialized() {
        this.detectScrollable();
        super.initialized();
    }
    detectScrollable() {
        if (this.el.scrollHeight - 1 > this.el.clientHeight)
            this.scrollable = true;
        else
            this.scrollable = false;
    }
    resize() {
        super.resize();
        this.detectScrollable();
    }
    flush() {
        super.flush();
    }
}
export default Auth;
